import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  DEFAULT_EPISODE_DISPLAY,
  type EpisodeDisplayPreferences,
  type SortConfig,
  type ViewMode,
} from '@bastion/episodes';

const STORAGE_KEY = 'bastion.episodes.display';

export interface EpisodeDisplayState extends EpisodeDisplayPreferences {
  patch: (next: Partial<EpisodeDisplayPreferences>) => void;
  setSort: (sort: SortConfig) => void;
  setViewMode: (viewMode: ViewMode) => void;
  setPageSize: (pageSize: number) => void;
  reset: () => void;
}

export const useEpisodeDisplayStore = create<EpisodeDisplayState>()(
  persist(
    (set) => ({
      ...DEFAULT_EPISODE_DISPLAY,
      patch: (next) => set((s) => ({ ...s, ...next })),
      setSort: (sort) => set({ sort }),
      setViewMode: (viewMode) => set({ viewMode }),
      setPageSize: (pageSize) => set({ pageSize }),
      reset: () => set(DEFAULT_EPISODE_DISPLAY),
    }),
    {
      name: STORAGE_KEY,
      partialize: (state) => ({
        viewMode: state.viewMode,
        sort: state.sort,
        pageSize: state.pageSize,
        hiddenFields: state.hiddenFields,
      }),
    },
  ),
);
